/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react';
import InnerBarDashboardPresenter from './InnerBarDashboardPresenter';
import DTOInnerBarDashboard from './DTOInnerBarDashboard';
import {
  clockOutLoader,
  clockOutReducer,
} from '../../../infra/aggregates/clockOutSlice';
import {
  canClockIn,
  clockInReducer,
} from '../../../infra/aggregates/clockInSlice';

import { clockOutService } from '../../../api/services/clockOutService';

import { useAppDispatch, useAppSelector } from '../../../infra/hooks';
import toast from 'react-hot-toast';
import { clockInService } from '../../../api/services/clockInService';
import { useTranslation } from 'react-i18next';

function InnerbarDashboardController() {
  const { t } = useTranslation();

  const dispatch = useAppDispatch();
  const selector = useAppSelector((state) => state);
  const [innerBarDashboardData, setInnerBarDashboardData] = useState({});
  const [birthdayList, setBirthdayList] = useState([]);
  const [last_checkInTime, setLast_checkInTime] = useState('');
  const [check_in_status, setCheck_in_status] = useState<any>();
  const [tempLoading, setTempLoading] = useState(false);

  const isLoading = useAppSelector(
    (state) => state.clockOutSlice.clockOutLoader,
  );

  const storedLastCheckInTime = useAppSelector(
    (state) => state.clockInSlice.last_checkIn_time,
  );
  const storedCheckInStatus = useAppSelector(
    (state) => state.clockInSlice.can_checkin,
  );
  useEffect(() => {
    setTempLoading(true);
    clockInService.can_checkin(selector.authSlice.emp_id).then((res) => {
      dispatch(
        canClockIn({
          can_checkin: res?.data?.can_checkin,
          last_checkin: res?.data?.last_checkin,
        }),
      );
      setLast_checkInTime(res?.data?.last_checkin);
      setCheck_in_status(
        res?.data?.can_checkin != '' ? res?.data?.can_checkin : true,
      );
      setTempLoading(false);
    });
  }, []);

  useEffect(() => {
    dispatch(clockOutLoader(true));

    setLast_checkInTime(storedLastCheckInTime);
    setCheck_in_status(storedCheckInStatus);
    dispatch(clockOutLoader(false));
  }, [storedLastCheckInTime, storedCheckInStatus]);

  function callback(data: any) {
    setInnerBarDashboardData(data);
  }

  function callBackClockOut(data: any) {
    const companyId = selector.authSlice.company_id;
    const empId = selector.authSlice.emp_id;

    let lattitude: any;
    let longitude: any;
    navigator.geolocation.getCurrentPosition(
      async (pos) => {
        lattitude = pos?.coords?.latitude;
        longitude = pos?.coords?.longitude;
        if (data?.time && companyId && empId) {
          clockOut(data?.time, empId, lattitude, longitude, companyId);
        }
      },
      function () {
        toast.error(t('Error fetching your current location'));
      },
    );
  }
  async function clockOut(
    checkOutTime: any,
    empId: number,
    lat: any,
    lng: any,
    companyId: any,
  ) {
    dispatch(clockOutLoader(true));
    clockOutService
      .check_out(checkOutTime, empId, lat, lng, companyId)
      .then((response: any) => {
        if (response) {
          setCheck_in_status(true);
          dispatch(
            canClockIn({
              can_checkin: true,
              last_checkin: response?.data?.clock_in,
            }),
          );
          dispatch(clockInReducer(response?.data?.data?.clock_in));
          dispatch(clockOutReducer(response?.data?.data?.clock_out));
          toast.success(t('Clocked out Successfully'));
        } else {
          return;
        }
      })
      .catch((err) => {
        toast.error(
          err?.error?.data?.error_message
            ? err?.error?.data?.error_message
            : err?.error?.data?.message,
        );
      });

    clockInService.can_checkin(empId).then((res) => {
      dispatch(
        canClockIn({
          can_checkin: res?.data?.can_checkin,
          last_checkin: res?.data?.last_checkin,
        }),
      );
      setLast_checkInTime(res?.data?.last_checkin);
      setCheck_in_status(res?.data?.can_checkin);

      dispatch(clockOutLoader(false));
    });
  }

  function getBirthdayData(data: any) {
    setBirthdayList(data);
  }
  return (
    <div>
      <DTOInnerBarDashboard
        setInnerBarData={callback}
        setBirthdayData={getBirthdayData}
      />
      <InnerBarDashboardPresenter
        setClockOut={callBackClockOut}
        data={innerBarDashboardData}
        birthdayData={birthdayList}
        status={storedCheckInStatus}
        last_checkInTime={last_checkInTime}
        isLoading={isLoading}
        tempLoading={tempLoading}
        trans={t}
      />
    </div>
  );
}

export default InnerbarDashboardController;
